import { TakerMarket } from '@/enterprise/data/useTakerMarkets';
import { useOfferBuilderContext } from './OfferBuilderContext';

export interface DraftRateDetails {
  rate?: number;
  rateType?: 'APR' | 'DISC';
}

const useDraftRateDetails = () => {
  const {
    state: { draftOfferProperties },
  } = useOfferBuilderContext();

  const getDraftRateDetails = (takerMarket: TakerMarket): DraftRateDetails => {
    if (!draftOfferProperties) {
      return { rate: undefined, rateType: undefined };
    }

    // Always use rateInformations to find the rate for the specific market
    const takerMarketRateInformation = draftOfferProperties.rateInformations.find((rateInfo) => {
      return (
        rateInfo.marketUuid === takerMarket.marketUuid &&
        rateInfo.supplierDivisionUuid === takerMarket.takerDivisionUuid
      );
    });

    if (!takerMarketRateInformation) {
      return { rate: undefined, rateType: undefined };
    }

    // REF rates are stored as 'REF' in rateInformations but displayed as 'APR'
    const displayRateType =
      takerMarketRateInformation.rateInformation.rateType === 'REF'
        ? 'APR'
        : takerMarketRateInformation.rateInformation.rateType;

    return {
      rate: takerMarketRateInformation.rateInformation.rate,
      rateType: displayRateType as 'APR' | 'DISC',
    };
  };

  return {
    getDraftRateDetails,
  };
};

export default useDraftRateDetails;
